import React from 'react';
import { useTranslations } from 'next-intl';
import { MdOutlineClose } from 'react-icons/md';
import { PuffLoader } from 'react-spinners';
import { ResimdoIcon } from '../ResimdoIcon';
import { CustomSelect } from '../CustomSelect';
import { useGalleryPageState } from './GalleryPageContext';

import classes from './GalleryPage.module.scss';
import filterClasses from './GalleryPageFilters.module.scss';

export const GalleryPageFilters: React.FC = () => {
  const { data, actions } = useGalleryPageState();
  const t = useTranslations('galleryFilters');

  const {
    useCaseTaxonomy,
    productsTaxonomy,
    selectedUseCase,
    selectedProduct,
    searchQuery,
    loading,
    error,
    useCaseTaxonomies,
    productTaxonomies,
    hideFilterBar,
    hideSearchBar,
  } = data;

  const { setSelectedUseCase, setSelectedProduct, setSearchQuery } = actions;

  if (loading) {
    return (
      <div role="status" aria-label="Loading" style={{ display: 'flex', justifyContent: 'center' }}>
        <PuffLoader color="#fff" size={32} aria-hidden="true" />
      </div>
    );
  }

  if (error) {
    return <div style={{ color: 'red', marginBottom: '1rem' }}>Error: {error}</div>;
  }

  // Determine which filters to show
  const showUseCaseFilter =
    !hideFilterBar && (!useCaseTaxonomies || useCaseTaxonomies.length === 0);
  const showProductFilter =
    !hideFilterBar && (!productTaxonomies || productTaxonomies.length === 0);
  const showSearchBar = !hideSearchBar;
  const showAnyFilter = showUseCaseFilter || showProductFilter;

  return (
    <>
      {/* Search Input */}
      {showSearchBar && (
        <div style={{ marginBottom: '0.75rem', position: 'relative' }}>
          <div className={classes.searchWrapper}>
            <ResimdoIcon icon="suche" size="XXS" color="#FFFFFF" backgroundColor="transparent" />
            <input
              type="text"
              placeholder={t('search')}
              value={searchQuery}
              onChange={e => setSearchQuery(e.target.value)}
              className={classes.searchInput}
            />
          </div>
        </div>
      )}

      {/* Taxonomy Filters */}
      {showAnyFilter && (
        <div className={filterClasses.taxonomyFiltersWrapper}>
          <div className={filterClasses.taxonomyFilters}>
            {showUseCaseFilter && (
              <div className={filterClasses.filterItem}>
                <CustomSelect
                  items={useCaseTaxonomy
                    .filter(item => !item?.hide)
                    .map(item => ({
                      id: item.id,
                      label: item.label,
                    }))
                    .sort((a, b) => a.label.localeCompare(b.label))}
                  placeholder={t('useCase')}
                  selectedKey={selectedUseCase}
                  onSelectionChange={key => setSelectedUseCase(key as string)}
                />
              </div>
            )}

            {showProductFilter && (
              <div className={filterClasses.filterItem}>
                <CustomSelect
                  items={productsTaxonomy
                    .filter(item => !item?.hide)
                    .map(item => ({
                      id: item.id,
                      label: item.label,
                    }))
                    .sort((a, b) => a.label.localeCompare(b.label))}
                  placeholder={t('product')}
                  selectedKey={selectedProduct}
                  onSelectionChange={key => setSelectedProduct(key as string)}
                />
              </div>
            )}
          </div>
          {(showUseCaseFilter || showProductFilter) && (selectedUseCase || selectedProduct) && (
            <div className={filterClasses.clearFilters}>
              <button
                className={filterClasses.clearButton}
                onClick={() => {
                  setSelectedUseCase('');
                  setSelectedProduct('');
                }}
              >
                <MdOutlineClose />
                <span>Filter entfernen</span>
              </button>
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default GalleryPageFilters;
